export default __webpack_public_path__ + "static/media/PIEZAS.78017db8.png";